import { ResetFilters } from './ResetFilters'
import { Text } from '@components/_rcpo/ui/Text'
import { Icon } from '@components/gassan-ui'
import { Button } from '@components/old-rolex-ui'
import * as Dialog from '@radix-ui/react-dialog'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

type MobileFiltersProps = {
  renderFilters: React.ReactNode
}

export const MobileFilters: FC<MobileFiltersProps> = ({ renderFilters }) => {
  const { t } = useTranslation('rolex')
  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <button className="flex items-center gap-2 text-rolexPrimary">
          <Text variant="regular" className="font-medium text-inherit">
            Filters
          </Text>
          <svg height="11" width="11" viewBox="0 0 11 11" fill="currentColor">
            <path d="m11 6.15h-4.85v4.85h-1.3v-4.85h-4.85v-1.3h4.85v-4.85h1.3v4.85h4.85z" />
          </svg>
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[100] h-screen w-screen bg-shade-800/30">
          <Dialog.Content className="relative h-screen w-screen overflow-auto bg-white px-4 py-8">
            {renderFilters}
            <div className="fixed bottom-0 flex w-full items-center bg-white py-4">
              <Dialog.Close asChild>
                <Button variant="primary">{t('filters.viewResults')}</Button>
              </Dialog.Close>
              <ResetFilters />
            </div>
            <Dialog.Close asChild>
              <button className="absolute right-4 top-4 border-none outline-none">
                <Icon icon="cross" />
              </button>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
